import { Component, Vue, Prop } from 'vue-property-decorator';
import { LabelSetting } from '../../../../../../../../i18n/locale-helper';
import { convertHREF } from "../../../../../../../../utils/util";

@Component({
	template: require('./template.html'),
})
class SendMessageTemplateComponent extends Vue {
	@Prop()
	data: any

	constructor() {
		super();
	}

	get lblSetting() {
		return LabelSetting.Global;
	}

	get lblActionSetting() {
		return LabelSetting.Action;
	}

	get personId() {
		if (this.data.Data && this.data.Data.Status && this.data.Data.Status.PersonId) return this.data.Data.Status.PersonId;
		return '';
	}

	get personIdent() {
		if (this.data.Data && this.data.Data.Status && this.data.Data.Status.PersonIdent) return this.data.Data.Status.PersonIdent;
		return '';
	}

	get personEmail() {
		if (this.data.Data && this.data.Data.Status && this.data.Data.Status.PersonEmail) return this.data.Data.Status.PersonEmail;
		return '';
	}

	getConvertHREF(value: string) { return convertHREF(value); }
}

export default SendMessageTemplateComponent;